import SvgCheck from '@hc-frontend/core-icons/kit/check';
import SwapHoriz from '@hc-frontend/core-icons/kit/swap-horiz';
import { RatingStars } from '@hc-frontend/core-ui';
import { useCallback, useEffect, useState } from 'react';

import ReconnectionDisclaimer from '../call-status-reconnection-disclaimer/reconnection-disclaimer';

export default function CallReview({
  connectToSomeoneElse,
  formattedPhoneNumber,
}: {
  connectToSomeoneElse: () => void;
  formattedPhoneNumber: string;
}) {
  const [rating, setRating] = useState(0);
  const [review, setReview] = useState('');
  const [customerSatisfied, setCustomerSatisfied] = useState(false);

  const submitReview = useCallback(() => {
    // TODO: MP-2209 Submit review
    if (rating !== 0 || review.length > 0) {
      console.log('Should submit review', JSON.stringify({ rating, review }));
    }
  }, [rating, review]);

  useEffect(() => {
    submitReview();
  }, [rating, review, submitReview]);

  if (customerSatisfied) {
    return (
      <div className={`text-center mt-8-8 font-bold text-lg`}>
        Thank you! Your feedback was submitted.
      </div>
    );
  }

  return (
    <div>
      <div className={`w-[80%] mx-auto`}>
        <div>
          <span className={`font-bold`}>Looks like the call has ended!</span>{' '}
          Tell us, how did it go?
        </div>
        <div>
          <RatingStars value={rating} onChange={(value) => setRating(value)} />
        </div>
        <div>
          <textarea
            data-testid="text-review"
            onBlur={(event) => setReview(event.target.value)}
            className={`w-full border-[1px] border-[rgba(0, 0, 0, 0.2)] rounded-lg px-16-16 py-12-12`}
            placeholder={`Tell us about your experience (optional)`}
          />
        </div>
        <div className={`mt-4-4`}>
          Was the agency able to help you? Would you perhaps like to speak to a
          different agency?
        </div>
      </div>
      <div className={`mt-16-16 flex gap-8-8`}>
        <button
          onClick={() => setCustomerSatisfied(true)}
          className={`py-8-8 rounded bg-[#0088FF] text-[#FFF] w-1/2 flex items-center justify-center gap-4-4`}
        >
          <SvgCheck className={`w-[22px] h-[22px]`} />
          The agency was helpful!
        </button>
        <button
          onClick={() => connectToSomeoneElse()}
          className={`py-8-8 rounded bg-[#FFF] w-1/2 border-[1px] border-[#F5A500]  flex items-center justify-center gap-4-4`}
        >
          <SwapHoriz className={`w-[22px] h-[22px]`} />
          Talk to someone else
        </button>
      </div>
      <ReconnectionDisclaimer formattedPhoneNumber={formattedPhoneNumber} />
    </div>
  );
}
